import mixpanel from 'mixpanel-browser';
// Do we have a local session key

mixpanel.init('c7f02a38c60c3415a0ca8df8761bb67b', {
    debug: true,
    secure_cookie: true
}); 

export function logUserInteraction(user_action, component, element) {
    mixpanel.track(user_action, {component, element})
}

export function logNavigation(load) {
    mixpanel.track('Navigation', {
        loadTime: load || undefined
    })
}

export function trackLinks(selector, user_action, component) {
    mixpanel.track_links(selector, user_action, {
        "referrer": document.referrer,
        component
    });
}

export function logApiRequest(url, time) {
    mixpanel.track('api', {
        apiPath: url,
        loadTime: time || undefined
    })
}

export function trackProductEvent(name, properties) {
    try {
        mixpanel.track(name, properties || {});
    } catch (e) {
        // Analytics must not block the banner.
    }
}